import { tv, type VariantProps } from '@workspace/lib';

export const buttonVariants = tv({
  base: 'inline-flex items-center justify-center gap-2 font-heading transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 cursor-pointer disabled:pointer-events-none font-semibold rounded-sm text-base px-sm py-3 min-w-45 h-11',
  variants: {
    variant: {
      primary: 'bg-primary text-white hover:bg-primary-500 disabled:bg-secondary-100 disabled:text-secondary-300',
      secondary:
        'border bg-white text-primary border-primary hover:bg-accent disabled:text-secondary-200 disabled:border-secondary-300',
      tertiary:
        'bg-secondary-400 text-white hover:bg-secondary-300 disabled:bg-secondary-100 disabled:text-secondary-300',
      text: 'text-primary bg-none border-none ring-none hover:text-primary-500 focus:ring-2 focus:!ring-primary focus:ring-offset-0!',
      softDisabled: 'bg-secondary-100 text-secondary-200',
    },
    site: {
      porta: '',
      portaNZ: '',
      redRec: '',
      easycraft: '',
    },
  },
  compoundVariants: [
    {
      variant: 'secondary',
      site: 'redRec',
      class: 'hover:bg-primary-100',
    },
    {
      variant: 'tertiary',
      site: 'redRec',
      class: 'bg-accent text-primary hover:bg-accent-400',
    },
  ],
  defaultVariants: { variant: 'primary', site: 'porta' },
});

export type ButtonVariants = VariantProps<typeof buttonVariants>;
